import { Box } from "@wix/design-system";
import { useExperiments, useTranslation } from "@wix/fe-essentials-standalone";
import {
  ChevronRightSmall,
  ContrastSmall,
  ExitSmall,
  SiteDuplicateSmall,
  UserSmall,
  HelpCircleSmall,
} from "@wix/wix-ui-icons-common";
import { useCallback } from "react";
import {
  ACCOUNT_SETTINGS_URL,
  MY_PROJECTS_URL,
  SIGN_OUT_URL,
} from "../../../consts";
import { MenuItem } from "./MenuItem";
import { useMobile } from "../../../hooks/useMobile";

export const MenuItems = ({
  setIsThemeDropdownVisible,
  setIsHelpDropdownVisible,
}: {
  setIsThemeDropdownVisible?: (isVisible: boolean) => void;
  setIsHelpDropdownVisible?: (isVisible: boolean) => void;
}) => {
  const isMobile = useMobile();
  const { t } = useTranslation();
  const { experiments } = useExperiments();
  const isShowAppThemeToggleEnabled = experiments.enabled(
    "specs.picasso.showAppThemeToggle",
  );
  const onNavigation = useCallback(
    (path?: string) => {
      if (isMobile) {
        if (path) {
          window.location.href = path;
        }
        return undefined;
      }
      setIsThemeDropdownVisible?.(false);
    },
    [setIsThemeDropdownVisible, isMobile],
  );
  return (
    <Box
      direction="vertical"
      width="100%"
      gap={isMobile ? 0 : 4}
      marginTop={isMobile ? 0 : 2}
    >
      {isMobile && (
        <>
          <MenuItem
            href={MY_PROJECTS_URL}
            prefixIcon={<SiteDuplicateSmall />}
            onMouseEnter={() => onNavigation(MY_PROJECTS_URL)}
          >
            {t("landing.header.mobile.my_sites")}
          </MenuItem>
          <MenuItem
            suffixIcon={<ChevronRightSmall />}
            prefixIcon={<HelpCircleSmall />}
            onMouseEnter={() => setIsHelpDropdownVisible?.(true)}
          >
            {t("landing.header.help")}
          </MenuItem>
        </>
      )}
      {isShowAppThemeToggleEnabled && (
        <MenuItem
          suffixIcon={<ChevronRightSmall />}
          prefixIcon={<ContrastSmall />}
          onMouseEnter={() => setIsThemeDropdownVisible?.(true)}
        >
          {t("landing.header.theme")}
        </MenuItem>
      )}
      <MenuItem
        href={ACCOUNT_SETTINGS_URL}
        prefixIcon={<UserSmall />}
        onMouseEnter={() => onNavigation(ACCOUNT_SETTINGS_URL)}
      >
        {t("landing.header.my_account")}
      </MenuItem>
      <MenuItem
        href={SIGN_OUT_URL}
        prefixIcon={<ExitSmall />}
        onMouseEnter={() => onNavigation(SIGN_OUT_URL)}
      >
        {t("landing.header.sign_out")}
      </MenuItem>
    </Box>
  );
};
